import { FieldType, ViewModelBase } from "@shoothill/core";
import { action } from "mobx";
import { RDDV2FormDocumentModel } from "./RDDV2FormDocumentModel";

export class RDDV2FormDocumentViewModel extends ViewModelBase<RDDV2FormDocumentModel> {
    constructor(item: RDDV2FormDocumentModel | null) {
        super(item ? item : new RDDV2FormDocumentModel());
        this.setDecorators(RDDV2FormDocumentModel);
    }

    @action
    public reset = () => {
        this.model.reset();
    };

    private isMyModelValid = async (): Promise<boolean> => {
        let isValid = true;
        if ((await this.isModelValid()) === false) {
            isValid = false;
        }

        return isValid;
    };

    public async isFieldValid(fieldName: keyof FieldType<RDDV2FormDocumentModel>): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
